import { AuthService } from 'src/app/core/auth/auth.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-register',
  templateUrl: './confirm-register.component.html',
  styleUrls: ['./confirm-register.component.css'],
})
export class ConfirmRegisterComponent implements OnInit {
  confirmarRegistroForm: FormGroup;
  token = '';
  action = 'register';
  title = 'Registro';
  buttonText = 'REGISTRARSE';
  cargando = false;
  verPassword1 = false;
  verPassword2 = false;

  constructor(private activateRoute: ActivatedRoute, private auth: AuthService) {
    // Formulario
    this.confirmarRegistroForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password1: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)([A-Za-z\d]|[^ ]){8,}$/),
      ]),
      password2: new FormControl(''),
    });

    this.confirmarRegistroForm.controls['password2'].setValidators([
      Validators.required,
      this.noIgual.bind(this.confirmarRegistroForm),
    ]);
  }

  ngOnInit(): void {
    this.auth.estaAutenticado('/home');

    this.activateRoute.queryParams.subscribe((params) => {
      if (params.email && params.ce) {
        this.confirmarRegistroForm.get('email').setValue(params.email);
        this.token = params.ce;
        this.action = params.action;

        if (params.action === 'register') {
          this.title = 'Registro';
          this.buttonText = 'REGISTRARSE';
        } else if (params.action === 'reset') {
          this.title = 'Resetear contraseña';
          this.buttonText = 'RESETEAR CONTRASEÑA';
        }
      }
    });
  }

  noIgual(control: FormControl): { [s: string]: boolean } {
    let forma: any = this;

    if (control.value !== forma.controls['password1'].value) {
      return {
        noiguales: true,
      };
    }
    return null;
  }

  onSubmit() {
    if (this.confirmarRegistroForm.valid) {
      this.cargando = true;

      let authData = {
        email: this.confirmarRegistroForm.controls.email.value,
        confirmAccountToken: this.token,
        resetPasswordToken: this.token,
        newPassword: this.confirmarRegistroForm.controls.password1.value,
        passwordConfirm: this.confirmarRegistroForm.controls.password2.value,
      };

      if (this.action == 'register') {
        this.auth.confirmarRegistro(authData).then(() => {
          this.cargando = false;
        });
      } else if (this.action == 'reset') {
        this.auth.confirmarResetearPassword(authData).then(() => {
          this.cargando = false;
        });
      }
    }
  }

  alternarVerPassword(idElement: string = null) {
    if (idElement) {
      let propiedad = 'ver' + idElement.charAt(0).toUpperCase() + idElement.slice(1);

      this[propiedad] = !this[propiedad];
      let elemento: any = document.getElementById(idElement);

      if (elemento) {
        elemento.type = this[propiedad] ? 'text' : 'password';
      }
    }
  }
}
